import React from 'react';
import Form from 'react-bootstrap/Form';
import classnames from 'classnames';

import styles from './Checkbox.module.scss';

const Checkbox = ({ children, className, ...props }) => (
  <Form.Check {...props} className={classnames(styles.boonCheckbox, className)}>
    {children}
  </Form.Check>
);

export default Checkbox;
